module.exports = __webpack_public_path__ + "static/img/fz_fz_what.4a1b45d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_fz_what.png
// module id = slvq
// module chunks = 0